$(document).ready(function(){

	var cookiesVal = Cookies.get('cookies');
	var cookiesAlertVal = Cookies.get('cookiesAlert');

	if (cookiesAlertVal !== 'false') {
		showCookies();
	} else {
		hideCookies();
	}
	
	// if (cookiesVal == 'allow') {
	// 	var trackingID = 'UA-127738563-1';
	// 	var trackingCode = '<!-- Global site tag (gtag.js) - Google Analytics --><script async src="https://www.googletagmanager.com/gtag/js?id='+ trackingID +'"></script><script>window.dataLayer=window.dataLayer || []; function gtag(){dataLayer.push(arguments);}gtag("js", new Date()); gtag("config", "'+ trackingID +'");</script>';
	// 	$('body').append(trackingCode);
	// }


	$('.close__cookies').on('click', function(){
		hideCookies();
		Cookies.set('cookiesAlert','false',{expires: 30});
	});

	$('.decline__cookies').on('click', function(){
		Cookies.set('cookies','decline',{expires: 30});
	});

	$('.allow__cookies').on('click', function(){
		Cookies.set('cookies','allow',{expires: 30});
	});


	function showCookies(){
		$('.cookies__wrapper').animate({
			'bottom': 0,
		},'fast');
	}

	function hideCookies(){
		$('.cookies__wrapper').animate({
			'bottom': -155,
		},'fast');
	}
	
});